export default __webpack_public_path__ + "b8526046a0f73f844ea71755452b87f8.png";